<ul>
    <div class="alarm-row text" [ngClass]="getNgClass()">
        <li data-cy="alarms-monitoring-channel-number" class="td">
            <div>
                {{ alarm.channel }}
            </div>
        </li>
        <li class="td td-name">
            <div>{{ alarm.name | uppercase }}</div>
        </li>
        <li class="td td-status">
            <app-alarm-status-icon
                [statusText]="alarm.level"
            ></app-alarm-status-icon>
            <div>{{ alarm.status | uppercase }}</div>
        </li>
        <li class="td">
            <div>{{ alarm.value }}</div>
        </li>
        <li class="td">{{ alarm.category | uppercase }}</li>
        <li class="td td-date">
            <div>
                {{ alarm.occurredAt | date: "yyyy/MM/dd" }}
            </div>
            <div>
                {{ alarm.occurredAt | date: "HH:mm:ss" }}
            </div>
        </li>
        <li class="td td-date">
            <div>
                {{ alarm.updatedAt | date: "yyyy/MM/dd" }}
            </div>
            <div>
                {{ alarm.updatedAt | date: "HH:mm:ss" }}
            </div>
        </li>
        <li class="td td-btn ack">
            <button
                data-cy="alarms-ack-button"
                (click)="emitAck()"
                class="primary"
                [disabled]="disableAckButton"
            >
                {{ "alarm.button.ack" | translate | uppercase }}
            </button>
        </li>
    </div>
</ul>
